export const Sex = {
  MALE: 'Male',
  FEMALE: 'Female',
};

export const SEX_NOT_PROVIDED_VALUE = 'NotProvided';
